export const CheckFrequency: { [key: number]: string } = {
  0: 'Jednorázově',
  1: 'Denně',
  7: 'Týdně',
  30: 'Měsíčně',
}
